<template>
  <div class="option-title">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.option-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: .5em;
}
</style>
